import { render } from "./BackerCenterThumbnail.vue?vue&type=template&id=56e22f88"
import script from "./BackerCenterThumbnail.vue?vue&type=script&lang=js"
export * from "./BackerCenterThumbnail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__